export default "__VITE_ASSET__e19a2e80__"